import { render, staticRenderFns } from "./InnerPlanking3.vue?vue&type=template&id=55f0a41c&"
import script from "./InnerPlanking3.vue?vue&type=script&lang=js&"
export * from "./InnerPlanking3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports